import { forwardRef } from "react";

import { cn } from "@/lib/utils";

import { PasswordInput } from "./PasswordInput";

interface IStyledPasswordInputProps extends React.ComponentProps<
  typeof PasswordInput
> {
  wrapperClassName?: string;
  isError?: boolean;
}

export const StyledPasswordInput = forwardRef<
  HTMLInputElement,
  IStyledPasswordInputProps
>(({ wrapperClassName, className, isError, ...props }, ref) => {
  return (
    <div className={cn("relative", wrapperClassName)}>
      <PasswordInput
        ref={ref}
        className={cn(
          // NOTE: NSAI-6470 — the same 40px as `StyledInput`. This was left at
          // 48px when NSAI-6259 shrank the text input, so every form holding
          // both (sign in, sign up, profile, integration credentials) drew its
          // password field a visible 8px taller than the field above it.
          "bg-input-background h-10 focus-visible:ring-1 focus-visible:ring-offset-0 focus-visible:border-ring",
          isError &&
            "border-destructive focus-visible:border-destructive focus-visible:ring-destructive",
          className,
        )}
        {...props}
      />
    </div>
  );
});
